import React, { useState, useEffect } from "react";
import { useOutletContext } from 'react-router-dom'; // Importante
import ReverseService from "../services/ReverseService";
import { FaCircle } from "react-icons/fa";
import { parseISO, format } from "date-fns";
import DispatchModal from "./modals/DispatchModal";
import InitiateReverseModal from "./modals/Reverse/InitiateReverseModal";
import { isSLAPassed, isSLANear } from "../utils/SLACalcs";
import { FaLongArrowAltDown } from "react-icons/fa";
import GenerateGEModal from "./modals/Reverse/GenerateGEModal";
import CollectModal from "./modals/Reverse/CollectModal";
import TiposColeta from "../enums/TiposColeta";
import CollectOrderService from "../services/CollectOrderService";
import SendToExpeditionModal from './modals/Reverse/SendToExpeditionModal';
import DispatchCollectOrderModal from "./modals/Reverse/GenerateGEModal";
import InformCollectModal from "./modals/Reverse/InformCollectModal";
import NotifyCollectorModal from "./modals/Reverse/NotifyCollectorModal";
import InitiateScreeningModal from "./modals/Reverse/InitiateScreeningModal";
import AcertoModal from "./modals/Reverse/AcertoModal";
import CollectOrderDetailsModal from "./modals/Reverse/CollectOrderDetailsModal";
import { startPolling } from "../utils/polling";
import { statusAlertaPortaria } from "../utils/alertaPortaria";

export default function Coletas() {

  const statusColor = {
    "ATIVO": "#0369a1",
    "PENDENTE": "#fde047",
    "ABERTO": "#fde047",
    "EM ANDAMENTO": "#38bdf8",
    "TRIAGEM": "#22c55e",
    "REPASSE PARA COLETA": "#bae6fd",
    "ROTA DE COLETA": "#38bdf8",
  }

  const { user } = useOutletContext(); // Acessando o user pelo context

  const [collectOrderDetailsModal, setCollectOrderDetailsModal] = useState(false);
  const [collectOrderOnDetailsModal, setCollectOrderOnDetailsModal] = useState();

  const [collectOrdersOpenList, setCollectOrdersOpenList] = useState([]);
  const [collectOrdersListTriagem, setCollectOrdersListTriagem] = useState([]);

  const [collectOrdersRota, setCollectOrdersRota] = useState([]);

  const [generateGEModal, setGenerateGEModal] = useState(false);
  const [collectOrderOnGenerateGEModalModal, setCollectOrderOnGenerateGEModalModal] = useState();

  const [informCollectModal, setInformCollectModal] = useState(false);
  const [collectOrderOnInformCollectModal, setCollectOrderOnInformCollectModal] = useState();

  const [notifyCollectorModal, setNotifyCollectorModal] = useState(false);
  const [collectOrderOnNotifyCollectorModal, setCollectOrderOnNotifyCollectorModal] = useState();

  const [collectModal, setCollectModal] = useState(false)
  const [collectOrderOnCollectModal, setCollectOrderOnCollectModal ] = useState()

  const [collectOrderToExpeditionModal, setCollectOrderToExpeditionModal] = useState(false);
  const [collectOrderOnExpeditionModal, setCollectOrderOnExpeditionModal] = useState();

  const [collectOrderToAcertoContabilModal, setCollectOrderToAcertoContabilModal] = useState(false);
  const [collectOrderOnAcertoContabilModal, setCollectOrderOnAcertoContabilModal] = useState();

  const [dispatchCollectOrderModal, setDispatchCollectOrderModal] = useState(false);
  const [collectOrderOnDispatchModal, setCollectOrderOnDispatchModal] = useState();

  const [initiateScreenningCollectModal, setInitiateScreenningCollectModal] = useState(false);
  const [collectOrderOninitiateScreenningModal, setCollectOrderOninitiateScreenningModal] = useState();

  const [currentPageAbertas, setCurrentPageAbertas] = useState(1);
  const [currentPageRota, setCurrentPageRota] = useState(1);
  const [currentPageTriagem, setCurrentPageTriagem] = useState(1);

  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState('');

  // ================= USEEFFECT PARA BUSCAR COLETAS ABERTAS =================
  useEffect(()=>{
    const status = 'ABERTO'
    const fetchColetasAbertas = async () => {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      const queryString = params.toString();

      const collectOrdersOpen = await CollectOrderService.getCollectOrders(`?${queryString}`, currentPageAbertas);
      setCollectOrdersOpenList(collectOrdersOpen);
    }
    // Chamada inicial
    fetchColetasAbertas();
    return startPolling(fetchColetasAbertas);
  }, [currentPageAbertas, collectOrderToExpeditionModal, collectOrderToAcertoContabilModal, search])

  // ================= USEEFFECT PARA BUSCAR COLETAS ROTA DE COLETA =================
  useEffect(()=>{
    const status = 'ROTA DE COLETA'
    const fetchColetasRota = async () => {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      const queryString = params.toString();
      
      const collectOrdersRota = await CollectOrderService.getCollectOrders(`?${queryString}`, currentPageRota);
      setCollectOrdersRota(collectOrdersRota)
    }
    // Chamada inicial
    fetchColetasRota();
    return startPolling(fetchColetasRota);
  }, [currentPageRota, informCollectModal, collectOrderToExpeditionModal, notifyCollectorModal, search])

  // ================= USEEFFECT PARA BUSCAR COLETAS TRIAGEM =================
  useEffect(()=>{
    const status = 'TRIAGEM'
    const fetchColetasTriagem = async () => {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      const queryString = params.toString();
      
      const collectOrdersTriagem = await CollectOrderService.getCollectOrders(`?${queryString}`, currentPageTriagem);
      setCollectOrdersListTriagem(collectOrdersTriagem)
    }
    // Chamada inicial
    fetchColetasTriagem();
    return startPolling(fetchColetasTriagem);
  }, [currentPageTriagem, initiateScreenningCollectModal, informCollectModal, search])


  const handleCollectOrderDetailsModal = async (cOrderId) => {
    setCollectOrderDetailsModal(true)
    setCollectOrderOnDetailsModal(cOrderId)
  };

  const handleCollectOrderGE = async (collectOrderId) => {
    setGenerateGEModal(true)
    setCollectOrderOnGenerateGEModalModal(collectOrderId)
  };

  const handleInformCollect = async (collectOrderId) => {
    setInformCollectModal(true)
    setCollectOrderOnInformCollectModal(collectOrderId)
  }

  const handleNotificarColetor = async (collectOrderId) => {
    setNotifyCollectorModal(true)
    setCollectOrderOnNotifyCollectorModal(collectOrderId)
  }

  const handleColetar = async (collectOrderId) => {
    setCollectModal(true)
    setCollectOrderOnCollectModal(collectOrderId)
  };

  const handleDispatchCollectOrder = async (collectOrderId) => {
    setCollectOrderToExpeditionModal(true)
    setCollectOrderOnExpeditionModal(collectOrderId)
  };

  const handleAcertoContabilCollectOrder = async (collectOrderId) => {
    setCollectOrderToAcertoContabilModal(true)
    setCollectOrderOnAcertoContabilModal(collectOrderId)
  };

  const handleItiateScreenningModal = async (collectOrderId) => {
    setInitiateScreenningCollectModal(true)
    setCollectOrderOninitiateScreenningModal(collectOrderId)
  }

  // Coletas que já estavam em rota antes do indicador existir têm coletor
  // gravado e nenhum resumo de alerta. Marcá-las como não notificadas seria
  // alarme falso, então o coletor preenchido vale como sinal de que houve envio.
  const alertaDaColeta = (collectOrder) => {
    const alerta = statusAlertaPortaria(collectOrder, {
      legadoNotificado: Boolean(collectOrder?.coletor?.nome),
    });

    // Aqui "sem registro" é mais forte que no Monitor: as duas rotas que
    // notificam gravam o coletor, então coleta sem coletor e sem resumo quer
    // dizer que ninguém foi avisado — e isso ainda dá para resolver no botão.
    if (alerta.estado === 'sem-registro') {
      return {
        ...alerta,
        rotulo: 'Não notificada',
        detalhe: 'Esta coleta saiu em rota sem alerta para a portaria.',
      };
    }

    return alerta;
  };

  const getDescricaoByCod = (cod) => {
    const tipo = TiposColeta.find(item => item.cod === cod);
    return tipo ? tipo.descricao : 'Código não encontrado';
  };

  const handlePageChangeAbertas = (newPage) => {
    if (newPage >= 1 && newPage <= collectOrdersOpenList?.totalPages) {
      setCurrentPageAbertas(newPage);
    }
  };

  const handlePageChangeRota = (newPage) => {
    if (newPage >= 1 && newPage <= collectOrdersRota?.totalPages) {
      setCurrentPageRota(newPage);
    }
  };

  const handlePageChangeTriagem = (newPage) => {
    if (newPage >= 1 && newPage <= collectOrdersListTriagem?.totalPages) {
      setCurrentPageTriagem(newPage);
    }
  };

  const handleSearchChange = (e) => {
    // setSearch(e.target.value);
    setTempSearch(e.target.value); // Atualiza o estado temporário
    
    setCurrentPageAbertas(1)
    setCurrentPageRota(1)
    setCurrentPageTriagem(1)
  };

  const handleSearchBlur = () => {
    setSearch(tempSearch); // Atualiza o estado principal quando o input perde o foco
    console.log(tempSearch)
    setCurrentPageAbertas(1)
    setCurrentPageRota(1)
    setCurrentPageTriagem(1)
  };

  const clearFilters = () => {
    setSearch('');
    setTempSearch('');
    // setStartDate('');
    // setEndDate('');
    // // setStatus('');
  };


  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full min-h-full rounded-xl py-8 px-6 gap-3 bg-white">

        {/* Filtros de Busca */}
        <div className="flex items-end w-full rounded-md gap-4 text-[10px]">
          <div className="flex space-x-4 text-[12px]">
            <div className="flex flex-col">
              <label className="font-semibold ms-2">Número da Solicitação</label>
              <input
                type="text"
                placeholder="Search"
                value={tempSearch}  // Vincula o valor ao estado temporário
                onChange={handleSearchChange}  // Atualiza o estado temporário em tempo real
                onBlur={handleSearchBlur}  // Atualiza o estado principal ao perder o foco
                className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
              />
            </div>
          </div>

          <div className="flex gap-2">
            <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
              Limpar Filtros
            </button>
          </div>
        </div>

        {/* ABERTAS */}
        <div className="flex flex-col gap-2 border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="w-full text-md font-semibold">
            <div className="flex justify-start items-center gap-2">
              <FaCircle
                color={statusColor['ABERTO']}
                size={15}
              />
              ABERTAS
            </div>
          </div>
          <div className="w-full">
            <div className="overflow-x-auto min-h-48">
              <table className="min-w-full bg-white rounded-lg text-[10px]">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="py-2 px-4 border-b rounded-tl-lg">ID</th>
                    {/* <th className="py-2 px-4 border-b">Status</th> */}
                    <th className="py-2 px-4 border-b">Solicitação Ref</th>
                    <th className="py-2 px-4 border-b">Tipo Coleta</th>
                    <th className="py-2 px-4 border-b">Criado em</th>
                    <th className="py-2 px-4 border-b">GMO</th>
                    <th className="py-2 px-4 border-b">Cod Sap</th>
                    <th className="py-2 px-4 border-b">Equipamento</th>
                    <th className="py-2 px-4 border-b">Qtd Coleta</th>
                    <th className="py-2 px-4 border-b">Endereço</th>
                    <th className="py-2 px-4 border-b">Complemento</th>
                    <th className="py-2 px-4 border-b">Empresa</th>
                    <th className="py-2 px-4 border-b">Contato</th>
                    <th className="py-2 px-4 border-b">Telefone</th>
                    <th className="py-2 px-4 border-b">SLA Coleta</th>
                    {/* {user.role !== 'warehouse' &&  */}
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    {/* } */}
                  </tr>
                </thead>
                <tbody>
                  {collectOrdersOpenList?.collectOrders?.map((collectOrder, index) => (
                    <tr key={index} className="border-b hover:bg-gray-100">
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2 whitespace-nowrap cursor-pointer underline font-bold" onClick={()=>handleCollectOrderDetailsModal(collectOrder?._id)}>{collectOrder?.idCollectOrder}</div></td>
                      {/* <td className="py-1 px-4">
                        <div className="flex justify-start items-center gap-2">
                          <FaCircle
                            className="animate-pulse"
                            color={statusColor[collectOrder?.status]}
                            size={15}
                          />
                          {collectOrder?.status}
                        </div>
                      </td> */}
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.idRequest ? collectOrder?.idRequest : 'AVULSO'}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{getDescricaoByCod(collectOrder?.tipoColeta)}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{format(parseISO(collectOrder?.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.gmo.cidade === "SÃO PAULO" ? `SP - ${collectOrder.gmo.identificador}` : `${collectOrder.gmo.cidade}`}</div></td>
                      <td className="py-1 px-4 whitespace-nowrap"><div className="flex justify-center items-center gap-2">{collectOrder?.codEquipamentoColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder?.nomeEquipamentoColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.qtdColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColetaComplemento}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.empresaTecnico?.socialName}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.nomeSolicitante}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.contatoSolicitante}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.slaCollectDate ? format(parseISO(collectOrder.slaCollectDate), 'dd/MM/yy HH:mm') : ""}</div></td>
                      {/* {user.role !== 'warehouse' && */}
                        <td className="py-1 px-4">
                          <div className="flex justify-center gap-2">
                          <div className="flex justify-center gap-2 h-5 text-[11px]">
                            <button
                              className="bg-gray-700 rounded-full px-2 text-white whitespace-nowrap"
                              onClick={() => { handleCollectOrderGE(collectOrder._id) }}
                            >
                              GE
                            </button>
                              <button
                                className=" bg-yellow-600 rounded-full px-2 text-white"
                                onClick={() => { handleDispatchCollectOrder(collectOrder._id) }}
                              >
                                Expedir
                              </button>
                              {user.role === 'vivogestao' &&
                                <button
                                  className="bg-amber-500 rounded-full px-2 whitespace-nowrap"
                                  onClick={() => { handleAcertoContabilCollectOrder(collectOrder._id) }}
                                >
                                  Acerto
                                </button>
                              }
                            </div>
                          </div>
                        </td>
                      {/* } */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                onClick={() => handlePageChangeAbertas(currentPageAbertas - 1)}
                disabled={currentPageAbertas === 1}
                className={`px-2 py-1 rounded-md ${currentPageAbertas === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
              >
                {'<'}
              </button>

              {/* Botão para a primeira página */}
              {currentPageAbertas > 2 && (
                <>
                  <button
                    onClick={() => handlePageChangeAbertas(1)}
                    className="px-2 py-1 rounded-md bg-gray-300"
                  >
                    1
                  </button>
                  {currentPageAbertas >= 3 && <span className="px-2 py-1">...</span>}
                </>
              )}

              {/* Botões ao redor da página atual */}
              {Array.from({ length: 3 }, (_, i) => {
                const page = currentPageAbertas - 1 + i;
                if (page > 0 && page <= collectOrdersOpenList?.totalPages) {
                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChangeAbertas(page)}
                      className={`px-2 py-1 rounded-md ${page === currentPageAbertas ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {/* Botão para a última página */}
              {currentPageAbertas < collectOrdersOpenList?.totalPages - 1 && (
                <>
                  {currentPageAbertas < collectOrdersOpenList?.totalPages - 2 && <span className="px-2 py-1">...</span>}
                  <button
                    onClick={() => handlePageChangeAbertas(collectOrdersOpenList?.totalPages)}
                    className="px-2 py-1 rounded-md bg-gray-300"
                  >
                    {collectOrdersOpenList?.totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => handlePageChangeAbertas(currentPageAbertas + 1)}
                disabled={currentPageAbertas === collectOrdersOpenList?.totalPages}
                className={`px-2 py-1 rounded-md ${currentPageAbertas === collectOrdersOpenList?.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
              >
                {'>'}
              </button>
            </div>

          </div>
        </div>

        {/* ROTA DE COLETA */}
        <div className="flex flex-col gap-2 border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="w-full text-md font-semibold">
            <div className="flex justify-start items-center gap-2">
              <FaCircle
                color={statusColor['ROTA DE COLETA']}
                size={15}
              />
              ROTA DE COLETA
            </div>
          </div>
          <div className="w-full">
            <div className="overflow-x-auto min-h-48">
              <table className="min-w-full bg-white rounded-lg text-[10px]">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="py-2 px-4 border-b rounded-tl-lg">Agente</th>
                    {/* <th className="py-2 px-4 border-b">Status</th> */}
                    <th className="py-2 px-4 border-b">ID</th>
                    <th className="py-2 px-4 border-b">Solicitação Ref</th>
                    <th className="py-2 px-4 border-b">Criado em</th>
                    <th className="py-2 px-4 border-b">Cod Sap</th>
                    <th className="py-2 px-4 border-b">Equipamento</th>
                    <th className="py-2 px-4 border-b">Cidade</th>
                    <th className="py-2 px-4 border-b">Endereço</th>
                    <th className="py-2 px-4 border-b">Qtd Coleta</th>
                    <th className="py-2 px-4 border-b">Empresa</th>
                    <th className="py-2 px-4 border-b">Solicitante</th>
                    <th className="py-2 px-4 border-b">Obs Coleta</th>
                    <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                    {/* {user.role !== 'warehouse' &&  */}
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    {/* } */}
                  </tr>
                </thead>
                <tbody>
                  {collectOrdersRota?.collectOrders?.map((collectOrder, index) => (
                    <tr key={index} className={`border-b hover:bg-gray-100 ${isSLAPassed(collectOrder.slaCollectDate) ? 'bg-red-50' : isSLANear(collectOrder.slaCollectDate) ? 'bg-yellow-50' : ''}`}>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.agent?.name}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2 whitespace-nowrap cursor-pointer underline font-bold" onClick={()=>handleCollectOrderDetailsModal(collectOrder?._id)}>{collectOrder?.idCollectOrder}</div></td>
                      {/* <td className="py-1 px-4">
                        <div className="flex justify-start items-center gap-2">
                          <FaCircle
                            color={statusColor[collectOrder?.status]}
                            size={15}
                          />
                          {collectOrder.status}
                        </div>
                      </td> */}
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.idRequest ? collectOrder?.idRequest : 'AVULSO'}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{format(parseISO(collectOrder.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.codEquipamentoColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.nomeEquipamentoColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.gmo.cidade === "SÃO PAULO" ? `SP - ${collectOrder.gmo.identificador}` : `${collectOrder.gmo.cidade}`}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.qtdColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.empresaTecnico?.socialName}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.nomeSolicitante} - {collectOrder.contatoSolicitante}</div></td>
                      <td className="py-1 px-4">{collectOrder.observacaoColeta}</td>
                      <td className={`py-1 px-4 ${isSLAPassed(collectOrder.slaCollectDate) ? 'text-red-500 font-bold' : isSLANear(collectOrder.slaCollectDate) ? 'text-yellow-600 font-bold' : ''} `}>
                        {collectOrder?.slaCollectDate ? format(parseISO(collectOrder.slaCollectDate), 'dd/MM/yy HH:mm') : ""}
                      </td>
                      {/* {user.role !== 'warehouse' &&  */}
                      <td className="py-1 px-4">
                        <div className="flex justify-start gap-2 h-5 text-[11px]">
                          <button
                            className="bg-gray-700 rounded-full px-2 text-white whitespace-nowrap"
                            onClick={() => { handleCollectOrderGE(collectOrder._id) }}
                          >
                            GE
                          </button>
                          {/* Saiu em rota sem alerta para a portaria: dá para
                              notificar depois, com a GE em anexo. A condição é
                              o alerta ter saído, não o coletor estar preenchido
                              — coletor gravado com e-mail que falhou é
                              justamente a falha que precisa ficar visível. */}
                          {alertaDaColeta(collectOrder).estado !== 'notificada'
                            ? <button
                                className="bg-red-600 rounded-full px-2 text-white whitespace-nowrap animate-pulse"
                                title={alertaDaColeta(collectOrder).detalhe}
                                onClick={()=>handleNotificarColetor(collectOrder._id)}
                              >
                                Notificar Coleta
                              </button>
                            : <div
                                className="flex items-center gap-1 text-green-700 whitespace-nowrap px-1"
                                title={alertaDaColeta(collectOrder).detalhe}
                              >
                                <FaCircle size={7} /> Portaria OK
                              </div>
                          }
                          <button
                            className=" bg-sky-700 rounded-full px-2 text-white whitespace-nowrap"
                            onClick={()=>handleInformCollect(collectOrder._id)}
                          >
                            Informar Coleta
                          </button>
                        </div>
                      </td>
                      {/* } */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                onClick={() => handlePageChangeRota(currentPageRota - 1)}
                disabled={currentPageRota === 1}
                className={`px-2 py-1 rounded-md ${currentPageRota === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
              >
                {'<'}
              </button>

              {/* Botão para a primeira página */}
              {currentPageRota > 2 && (
                <>
                  <button
                    onClick={() => handlePageChangeRota(1)}
                    className="px-2 py-1 rounded-md bg-gray-300"
                  >
                    1
                  </button>
                  {currentPageRota >= 3 && <span className="px-2 py-1">...</span>}
                </>
              )}

              {/* Botões ao redor da página atual */}
              {Array.from({ length: 3 }, (_, i) => {
                const page = currentPageRota - 1 + i;
                if (page > 0 && page <= collectOrdersRota?.totalPages) {
                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChangeRota(page)}
                      className={`px-2 py-1 rounded-md ${page === currentPageRota ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {/* Botão para a última página */}
              {currentPageRota < collectOrdersRota?.totalPages - 1 && (
                <>
                  {currentPageRota < collectOrdersRota?.totalPages - 2 && <span className="px-2 py-1">...</span>}
                  <button
                    onClick={() => handlePageChangeRota(collectOrdersRota?.totalPages)}
                    className="px-2 py-1 rounded-md bg-gray-300"
                  >
                    {collectOrdersRota?.totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => handlePageChangeRota(currentPageRota + 1)}
                disabled={currentPageRota === collectOrdersRota?.totalPages}
                className={`px-2 py-1 rounded-md ${currentPageRota === collectOrdersRota?.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
              >
                {'>'}
              </button>
            </div>

          </div>
        </div>

        {/* TRIAGEM */}
        <div className="flex flex-col gap-2 border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="w-full text-md font-semibold">
            <div className="flex justify-start items-center gap-2">
              <FaCircle
                color={statusColor['TRIAGEM']}
                size={15}
              />
              TRIAGEM
            </div>
          </div>
          <div className="w-full">
            <div className="overflow-x-auto min-h-48">
              <table className="min-w-full bg-white rounded-lg text-[10px]">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="py-2 px-4 border-b rounded-tl-lg">ID</th>
                    {/* <th className="py-2 px-4 border-b">Status</th> */}
                    <th className="py-2 px-4 border-b">Solicitação Ref</th>
                    <th className="py-2 px-4 border-b">Tipo Coleta</th>
                    <th className="py-2 px-4 border-b">Criado em</th>
                    <th className="py-2 px-4 border-b">GMO</th>
                    <th className="py-2 px-4 border-b">Cod Sap</th>
                    <th className="py-2 px-4 border-b">Equipamento</th>
                    <th className="py-2 px-4 border-b">Qtd Coleta</th>
                    {/* <th className="py-2 px-4 border-b">Endereço</th> */}
                    {/* <th className="py-2 px-4 border-b">Complemento</th> */}
                    <th className="py-2 px-4 border-b">Empresa</th>
                    <th className="py-2 px-4 border-b">Solicitante</th>
                    <th className="py-2 px-4 border-b">Coletor</th>
                    <th className="py-2 px-4 border-b">SLA Coleta</th>
                    <th className="py-2 px-4 border-b">Coletado em</th>
                    <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {collectOrdersListTriagem?.collectOrders?.map((collectOrder, index) => (
                    <tr key={index} className="border-b hover:bg-gray-100">
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2 whitespace-nowrap cursor-pointer underline font-bold" onClick={()=>handleCollectOrderDetailsModal(collectOrder?._id)}>{collectOrder?.idCollectOrder}</div></td>
                      {/* <td className="py-1 px-4">
                       <div className="flex justify-start items-center gap-2">
                          <FaCircle
                          className="animate-pulse"
                          color={statusColor[collectOrder?.status]}
                          size={15}
                        />
                        {collectOrder?.status}
                        </div>
                      </td> */}
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.idRequest}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{getDescricaoByCod(collectOrder?.tipoColeta)}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{format(parseISO(collectOrder?.createdAt), 'dd/MM/yy HH:mm')}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.gmo.cidade === "SÃO PAULO" ? `SP - ${collectOrder.gmo.identificador}` : `${collectOrder.gmo.cidade}`}</div></td>
                      <td className="py-1 px-4 whitespace-nowrap"><div className="flex justify-center items-center gap-2">{collectOrder?.codEquipamentoColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{collectOrder?.nomeEquipamentoColeta}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.qtdColeta}</div></td>
                      {/* <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColeta}</div></td> */}
                      {/* <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.enderecoColetaComplemento}</div></td> */}
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.empresaTecnico?.socialName}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.nomeSolicitante} - {collectOrder.contatoSolicitante}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.nomeColetor} - {collectOrder.telefoneColetor}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.slaCollectDate ?format(parseISO(collectOrder.slaCollectDate), 'dd/MM/yy HH:mm') : '' }</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder?.dataHoraColeta ? format(parseISO(collectOrder?.dataHoraColeta), 'dd/MM/yy HH:mm') : ''}</div></td>
                      <td className="py-1 px-4">
                        <div className="flex justify-center gap-2 h-5 text-[11px]">
                          <button 
                            className=" bg-green-600 rounded-full px-2 text-white whitespace-nowrap"
                            onClick={()=>{handleItiateScreenningModal(collectOrder._id)}}
                          >
                            Iniciar Triagem
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                onClick={() => handlePageChangeTriagem(currentPageTriagem - 1)}
                disabled={currentPageTriagem === 1}
                className={`px-2 py-1 rounded-md ${currentPageTriagem === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
              >
                {'<'}
              </button>

              {/* Botão para a primeira página */}
              {currentPageTriagem > 2 && (
                <>
                  <button
                    onClick={() => handlePageChangeTriagem(1)}
                    className="px-2 py-1 rounded-md bg-gray-300"
                  >
                    1
                  </button>
                  {currentPageTriagem >= 3 && <span className="px-2 py-1">...</span>}
                </>
              )}

              {/* Botões ao redor da página atual */}
              {Array.from({ length: 3 }, (_, i) => {
                const page = currentPageTriagem - 1 + i;
                if (page > 0 && page <= collectOrdersListTriagem?.totalPages) {
                  return (
                    <button
                      key={page}
                      onClick={() => handlePageChangeTriagem(page)}
                      className={`px-2 py-1 rounded-md ${page === currentPageTriagem ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {/* Botão para a última página */}
              {currentPageTriagem < collectOrdersListTriagem?.totalPages - 1 && (
                <>
                  {currentPageTriagem < collectOrdersListTriagem?.totalPages - 2 && <span className="px-2 py-1">...</span>}
                  <button
                    onClick={() => handlePageChangeTriagem(collectOrdersListTriagem?.totalPages)}
                    className="px-2 py-1 rounded-md bg-gray-300"
                  >
                    {collectOrdersListTriagem?.totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => handlePageChangeTriagem(currentPageTriagem + 1)}
                disabled={currentPageTriagem === collectOrdersListTriagem?.totalPages}
                className={`px-2 py-1 rounded-md ${currentPageTriagem === collectOrdersListTriagem?.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 text-white'}`}
              >
                {'>'}
              </button>
            </div>

          </div>
        </div>

      </div>

      {collectOrderOnDetailsModal &&
        <div className="absolute">
          <CollectOrderDetailsModal
            isModalOpen={collectOrderDetailsModal}
            setModalOpen={() => {
              setCollectOrderDetailsModal(!collectOrderDetailsModal);
            }}
            collectOrderId={collectOrderOnDetailsModal}
          // setTicketCb={setTicket}
          ></CollectOrderDetailsModal>
        </div>
      }

      {collectOrderOnCollectModal &&
        <div className="absolute">
          <CollectModal
            isModalOpen={collectModal}
            setModalOpen={() => {
              setCollectModal(!collectModal);
            }}
            collectOrderId={collectOrderOnCollectModal}
          // setTicketCb={setTicket}
          ></CollectModal>
        </div>
      }

      {collectOrderOnGenerateGEModalModal &&
        <div className="absolute">
          <GenerateGEModal
            isModalOpen={generateGEModal}
            setModalOpen={() => {
              setGenerateGEModal(!generateGEModal);
            }}
            collectOrderId={collectOrderOnGenerateGEModalModal}
          // setTicketCb={setTicket}
          ></GenerateGEModal>
        </div>
      }

      {collectOrderOnInformCollectModal &&
        <div className="absolute">
          <InformCollectModal
            isModalOpen={informCollectModal}
            setModalOpen={() => {
              setInformCollectModal(!informCollectModal);
            }}
            collectOrderId={collectOrderOnInformCollectModal}
          // setTicketCb={setTicket}
          ></InformCollectModal>
        </div>
      }

      {collectOrderOnNotifyCollectorModal &&
        <div>
          <NotifyCollectorModal
            isModalOpen={notifyCollectorModal}
            setModalOpen={() => {
              setNotifyCollectorModal(!notifyCollectorModal);
              setCollectOrderOnNotifyCollectorModal();
            }}
            collectOrderId={collectOrderOnNotifyCollectorModal}
          ></NotifyCollectorModal>
        </div>
      }

      {collectOrderOnExpeditionModal &&
        <div className="absolute">
          <SendToExpeditionModal
            isModalOpen={collectOrderToExpeditionModal}
            setModalOpen={() => {
              setCollectOrderToExpeditionModal(!collectOrderToExpeditionModal);
            }}
            collectOrderId={collectOrderOnExpeditionModal}
          // setTicketCb={setTicket}
          ></SendToExpeditionModal>
        </div>
      }
      
      {collectOrderOnAcertoContabilModal &&
        <div className="absolute">
          <AcertoModal
            isModalOpen={collectOrderToAcertoContabilModal}
            setModalOpen={() => {
              setCollectOrderToAcertoContabilModal(!collectOrderToAcertoContabilModal);
            }}
            collectOrderId={collectOrderOnAcertoContabilModal}
          // setTicketCb={setTicket}
          ></AcertoModal>
        </div>
      }

      {collectOrderOnDispatchModal &&
        <div className="absolute">
          <DispatchCollectOrderModal
            isModalOpen={dispatchCollectOrderModal}
            setModalOpen={() => {
              setDispatchCollectOrderModal(!dispatchCollectOrderModal);
            }}
            collectOrderId={collectOrderOnDispatchModal}
          // setTicketCb={setTicket}
          ></DispatchCollectOrderModal>
        </div>
      }


      {collectOrderOninitiateScreenningModal &&
        <div className="absolute">
          <InitiateScreeningModal
            isModalOpen={initiateScreenningCollectModal}
            setModalOpen={() => {
              setInitiateScreenningCollectModal(!initiateScreenningCollectModal);
            }}
            collectOrderId={collectOrderOninitiateScreenningModal}
          // setTicketCb={setTicket}
          ></InitiateScreeningModal>
        </div>
      }


    </div>
  )
}
